// extracted by mini-css-extract-plugin
export default {"card":"c-e_cX","card_styleDefault":"c-e_cY","card_styleRed":"c-e_cZ"};